import { Component, OnDestroy } from '@angular/core';
import { CustomDurationPipe } from '@app/shared/pipes/custom-duration.pipe';
import { DialogRef } from '@ngneat/dialog';
import { Store, select } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { GoogleTagManagerService } from '@app/core/lib/google-tag-manager/angular-google-tag-manager.service';
import moment, { Duration } from 'moment';
import { Constant } from 'src/constant';
import * as fromUploader from '@app/client/uploader/store/reducers';
import * as fromRoot from 'src/app/reducers';
import * as fromSignup from 'src/app/client/signup/reducers';
import { distinctUntilChanged, first, Observable, Subscription, withLatestFrom } from 'rxjs';
import { UploaderStatus } from '@smash-sdk/uploader';
import { PrepareActions, UploadActions } from '@app/client/uploader/store/actions';
import { environment } from 'src/environments/environment';
import { SubscriptionActions } from '@app/client/signup/subscription/actions';
import { GetPlanGroupOutput } from '@smash-sdk/billing/ejs/01-2024/types/GetPlanGroup/GetPlanGroup';
import { computeDiscountPercentage, computeOffer } from '@app/shared/helpers/price';
@Component({
  selector: 'app-modal-size-premium',
  templateUrl: './modal-size-premium.component.html',
  styleUrls: ['./modal-size-premium.component.scss']
})
export class ModalSizePremiumComponent implements OnDestroy {
  status$: Observable<UploaderStatus>;
  language$: Observable<string>;
  formatQueue: any;
  timer: Duration;
  timerFormat: string;
  interval: any;
  start: any;
  updatedTime: any;
  smashPremiumOffer: number;
  smashPremiumDiscount: number;
  smashPremiumCurrency: GetPlanGroupOutput['group']['plans'][0]['currency'];
  subscriptions: Subscription[] = [];
  hostname = environment.appDomainWithProtocol;
  constructor(
    private store: Store<fromUploader.State & fromRoot.State & fromSignup.State>,
    public ref: DialogRef,
    private customDurationPipe: CustomDurationPipe,
    private translateService: TranslateService,
    private gtmService: GoogleTagManagerService,
  ) {
    this.status$ = this.store.select(fromUploader.getUploadStatus);

    this.timer = moment.duration(this.ref.data.queue, 'seconds');
    this.start = moment();
    this.interval = setInterval(() => {
      this.updatedTime = moment();
      const diff = this.updatedTime.diff(this.start);
      this.timer = moment.duration(this.ref.data.queue, 'seconds');
      this.timer = this.timer.subtract(Math.floor(diff / 1000), 'second');
      this.timerFormat = `${this.timer.hours() < 10 ? '0' + this.timer.hours() : this.timer.hours()}:${this.timer.minutes() < 10 ? '0' + this.timer.minutes() : this.timer.minutes()}:${this.timer.seconds() < 10 ? '0' + this.timer.seconds() : this.timer.seconds()}`;
      if (this.timer.asMilliseconds() <= 0) {
        this.clearTimer();
      }
    }, 1000);

    this.formatQueue = this.customDurationPipe.transform(ref.data.queue);
    const countryCurrency = this.ref.data.countries.find((country: any) => country.countryCode === this.ref.data.countryCode)?.currency;
    this.subscriptions = [
      this.ref.backdropClick$.subscribe(() => {
        this.gtmService.pushTag({
          event: Constant.eventGTM.CLICK_BACKDROP_MODAL_SIZE_PREMIUM,
          transfer_size: ref.data.transferSize,
        });
        this.store.dispatch(PrepareActions.HideModalSizePremium());
      }),

    ];

    this.store.pipe(
      withLatestFrom(
        this.store.pipe(select(fromRoot.getCountriesLoaded)),
        this.store.pipe(select(fromSignup.getPlanGroupLoaded)),
        this.store.pipe(select(fromSignup.getPlans)),
      ),
      first(([_, countriesLoaded, planGroupLoaded]) => countriesLoaded && planGroupLoaded),
      distinctUntilChanged()
    ).subscribe(([_, countriesLoaded, planGroupLoaded, plans]) => {
      if (countriesLoaded && planGroupLoaded) {
        const smashPremium2years = plans.find(plan => plan.currency === countryCurrency && plan.duration === '2years');
        const { offer, currency } = computeOffer({ plan: smashPremium2years });
        this.smashPremiumOffer = offer;
        this.smashPremiumCurrency = currency;
        this.smashPremiumDiscount = computeDiscountPercentage({ plan: smashPremium2years, countryCurrency, plans });
      }
    });

    this.store.dispatch(SubscriptionActions.loadPlans({ id: "Smash Premium" }));
    this.language$ = this.store.select(fromRoot.getSelectedLanguage);
  }



  ngOnDestroy(): void {
    this.clearTimer();
    this.subscriptions.map((subscription: Subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }

  clearTimer() {
    clearInterval(this.interval);
    this.timerFormat = null;
  }

  onUploadAnonymous() {
    this.store.dispatch(PrepareActions.HideModalSizePremium());
    this.store.dispatch(UploadActions.UpdateAndResumeUpload());
    this.closeModal();
  }

  closeModal() {
    this.store.dispatch(PrepareActions.HideModalSizePremium());
    this.clearTimer();
    this.ref.close();
  }

  goSubscribe($event, URL) {
    window.location.href = this.translateService.instant(URL);
    $event.preventDefault();
    $event.stopPropagation();
  }
}
